<template lang="pug">
div
  template(v-if="error")
    .error {{error}}
  gmap-map(v-if="ready" ref="map" :center="center" :zoom="12" style="width: 100%; height: 500px")
    gmap-info-window(:options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false")
      .standort-name {{standort.name}}
      template(v-if="layer == 'projekte'")
        p(v-for="p in standort.projekte" :key="p.id")
          img(v-if="p.logo" :src="p.logo" :title="p.name")
          | {{p.name}}
      template(v-else-if="layer == 'it'")
      template(v-else-if="layer == 'it_anbieter'")
        span(v-for="a in standort.it_anbieter" :key="a.id")
          template(v-if="a.logo")
            img(:src="a.logo" :title="a.name")
          template(v-else)
            | {{a.name}}
        p
          | bandbreite Aktuell: {{standort.bandbreite_aktuell}}
          br
          |  bandbreite max: {{standort.bandbreite_max}}
      template(v-else-if="layer == 'it_email'")
        p
          | Mit/Ohne E-Mail: {{standort.mitarbeiter_mit_email}} / {{standort.mitarbeiter_ohne_email}}
      template(v-else-if="layer == 'it_tickets'")
        p
          | Tickets Offen/Geschlossen
          br
          |  {{standort.tickets_offen}} / {{standort.tickets_geschlossen}}
      template(v-else-if="layer == 'it_netzwerk'")
        p(v-if="standort.nas")
          | NAS: 
          span.checkmark ✓
        p(v-if="standort.vpn")
          | VPN: 
          span.checkmark ✓
        p(v-if="standort.he2exc")
          | He2Exc: 
          span.checkmark ✓
    gmap-marker(:key="i" v-for="(m, i) in filteredMarkers" :icon="{url: '/assets/logo-x.svg'}" :position="m.position" :clickable="true" @click="showStandort(i)" @mouseover="statusText = m.data.name" @mouseout="statusText = null")
    div(slot="visible")
      .statustext(v-if="statusText")
        | {{statusText}}
      #floating-panel
        select(v-if="arten.length > 1" v-model="art" on:change="artChanged()")
          option(v-for="a in arten" :key="a") {{a}}
        select(v-if="layers.length > 1" v-model="layer")
          option(v-for="l in layers" :value="l.value" :disabled="l.disabled" :key="l.value") {{l.label}}
        template(v-if="filteredMarkers.length > 1")
          button(@click="prev") Zurück
          button(@click="play" @mousedown="playMouseDown") {{playing ? 'Pause' : 'Play' }}
          input.num-input(:changed="playIntervalChanged()" v-if="showPlayInterval" v-model="playInterval" type="number")
          button(@click="next") Weiter
      .standort_table_wrapper
        table.standort_table
          tr
            th Name
            th Aussenstelle
          tr(v-for="(s, i) in standorte" :class="{ standort_active: i == currentMidx}" :key="i")
            td(@click="showStandort(i)") {{s.name}}
            td {{s.aussenstelle}}
  div(v-else style="height: 500px")
  .bottom-border.primary

</template>

<script>
import Vue from 'vue'

export default {
  data() {
    window.v = Vue
    window.x=this
    this.$http.get('/api/v1b/it_standorte').then( r => r.json() ).then(standorte => {
      if (standorte.length > 0) {
        this.standorte = standorte.filter(s => s.lat && s.lng);
        this.markers = this.standorte.map( s => {
          return {
            position: { lat: s.lat, lng: s.lng },
            data: s
          };
        });
        let s = this.standorte[0];
        let arten = [];
        if (s.projekte) {
          this.layers.push({ value: "projekte", label: "Projekte" });
          this.standorte.forEach(s => s.projekte.forEach(p => arten.push(p.art)));
        }
        if (s.it_anbieter) {
          this.layers.push({ value: "it", label: "IT", disabled: true });
          this.layers.push({ value: "it_anbieter", label: " -  Anbieter" });
          this.layers.push({ value: "it_netzwerk", label: " -  Netzwerk" });
          this.layers.push({ value: "it_email", label: " -  Email" });
          this.layers.push({ value: "it_tickets", label: " -  Tickets" });
        }
        this.arten = arten.sort().filter((art, i, arten) => arten.indexOf(art) === i);
        this.arten.unshift('Alle');
        this.center = { lat: s.lat, lng: s.lng };
        this.ready = true;
        this.fitBounds(this.markers);
      }
    }).finally(_ => {
      if (!this.ready) {
        this.error = 'Laden Fehlgeschlagen';
      }
    });
    return {
      ready: false,
      error: null,
      playing: false,
      art: 'Alle',
      arten: [],
      layer: 'name',
      layers: [
        { value: "name", label: "Name" }
      ],
      showPlayInterval: false,
      playInterval: 30,
      center: { lat: 0, lng: 0 },
      standorte: [],
      statusText: null,
      currentMidx: null,
      standort: {},
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
    };
  },
  computed: {
    filteredMarkers() {
      let markers = this.markers, art = this.art;
      if (!art || art == 'Alle') {
        return markers;
      }
      if (markers.length) {
        return markers.filter(m => m.data.projekte.find(p => p.art == art));
      } else {
        return [];
      }
    }
  },
  watch: {
    art() {
      if (this.markers.length) {
        this.showStandort(null);
      }
    }
  },
  methods: {
    artChanged(e) {
      console.log(e);
    },
    fitBounds(markers) {
      if (window.google && this.$refs.map) {
        var b = new google.maps.LatLngBounds();
        markers.forEach( m => b.extend(m.position))
        this.$refs.map.fitBounds(b);
      } else {
        setTimeout(this.fitBounds, 16, markers);
      }
    },
    prev() {
      let idx = this.currentMidx;
      if (idx == null) {
        idx = -1
      } else {
        idx = idx - 1
      }
      if (idx < 0) {
        idx = this.filteredMarkers.length - 1;
      }
      this.showStandort(idx);
    },
    next() {
      let idx = this.currentMidx;
      if (idx == null) {
        idx = 0
      } else {
        idx = idx + 1
      }
      if (idx >= this.filteredMarkers.length) {
        idx = 0;
      }
      this.showStandort(idx);
    },
    playMouseDown() {
      this.playMouseStart = new Date().getTime();
    },
    play() {
      let time = new Date().getTime() - this.playMouseStart;
      if (time < 200) {
        this.playing = !this.playing;
        if (this.playing) {
          this.playNext();
        } else {
          clearInterval(this.playTimeout);
        }
      } else {
        this.showPlayInterval = !this.showPlayInterval;
      }
    },
    playNext() {
      let i = this.currentMidx;
      if (i >= this.filteredMarkers.length - 1) {
        this.showStandort(null);
        clearInterval(this.playTimeout);
        this.playing = false;
      } else {
        this.next();
      }
    },
    playIntervalChanged(){
      if (this.playing) {
        clearInterval(this.playTimeout);
        this.playTimeout = setTimeout(this.playNext, this.playInterval * 1000);
      }
    },
    showStandort(idx) {
      var marker = this.filteredMarkers[idx];
      if (marker) {
        this.infoWindowPos = marker.position;
        this.standort = marker.data;

        this.$refs.map.panTo(marker.position);

        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      } else {
        this.infoWinOpen = false;
        this.currentMidx = null;
        this.fitBounds(this.filteredMarkers);
      }
      this.playIntervalChanged();
    }
  }
}
</script>

<style lang="scss" scoped>
  .bottom-border {
    height: 3em;
  }
  #floating-panel {
    position: absolute;
    top: 10px;
    right: 28px;
    z-index: 5;
    font-family: 'Roboto','sans-serif';
    line-height: 30px;
    select {
      display: block;
      width:100%;
      border: 1px solid #bbb;
      padding: .25em 1em .25em 1em;
      box-shadow: 0 2px 1px 0 rgba(0,0,0,0.2);
      background-color: white;
      &:hover {
        box-shadow: 0 1px 1px 0 rgba(0,0,0,0.1);
      }
    }
    .num-input {
      width: 4em;
      border: 1px solid #bbb;
      padding: .25em .25em .25em .75em;
      box-shadow: 0 2px 1px 0 rgba(0,0,0,0.2);
      background-color: white;
    }
    button {
      background-color: white;
      border: 1px solid #bbb;
      padding: .25em 1em .25em 1em;
      box-shadow: 0 2px 1px 0 rgba(0,0,0,0.2);
      &:hover {
        background-color: rgb(235, 235, 235);
        color: black;
      }
    }
  }
  .statustext {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: white;
    z-index: 100;
    padding: 0.5em;
  }
  .standort-name {
    font-weight: bold;
    padding-bottom: 0.5em;
  }
  .checkmark {
    color: green;
  }
  .error {
    color: red;
    padding: 1em;
    font-size: 1.2em;
    text-align: center;
  }
  .standort_table_wrapper {
    display: none;
    padding: 1em;
    background-color: white;
    overflow: auto;
    position: absolute;
    max-height: 250px;
    left: 12px;
    bottom: 30px;
    width: 0px;
    &:hover {
      width: 70%;
      .standort_table {
        display: table;
      }
    }
    .standort_table {
      display: none;
      width: 50%;
      tr {
        border-bottom: 1px solid gray;
        &.standort_active {
          font-weight: bold;
        }
      }
    }
  }
</style>
